import {
  EditBucketJourney,
  GetBucketJourney,
  RegisterBucketJourney,
} from "@/dtos/BucketJourney.dto";
import { StateObject } from "@/dtos/State.dto";
import BucketJourney from "@/services/bucket/bucket-journey";
import {
  CLEAR_BUCKET_JOURNEY_ISLOADING,
  DELETE_BUCKET_JOURNEY,
  EDIT_BUCKET_JOURNEY,
  GET_BUCKET_JOURNIES,
  REGISTER_BUCKET_JOURNEY,
} from "@/store/action-types";
import { SET_BUCKET_JOURNEY, SET_BUCKET_JOURNIES, SET_ERRORMSG } from "@/store/mutation-types";
import { AxiosResponse } from "axios";
import { Module } from "vuex";

const bucketJourney: Module<any, {}> = {
  state: {
    bucketJourney: {
      data: null,
      isLoading: false,
    },
    bucketJournies: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    bucketJourney: (state: { bucketJourney: any }) => state.bucketJourney,
    bucketJournies: (state: { bucketJournies: any }) => state.bucketJournies,
  },
  mutations: {
    [SET_BUCKET_JOURNEY]: (
      state: { bucketJourney: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.bucketJourney.data = payload.data;
      state.bucketJourney.isLoading = payload.isLoading;
    },
    [SET_BUCKET_JOURNIES]: (
      state: { bucketJournies: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.bucketJournies.data = payload.data;
      state.bucketJournies.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_BUCKET_JOURNEY]: async ({ commit }: any, payload: any) => {
      commit(SET_BUCKET_JOURNEY, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await BucketJourney.registerBucketJourney(
          payload as RegisterBucketJourney
        );

        if (result) {
          if (result.data.status) {
            commit(SET_BUCKET_JOURNEY, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_BUCKET_JOURNEY, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_BUCKET_JOURNEY, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_BUCKET_JOURNEY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, error.response?.data?.message || "Failed to register bucket journey");
        return false;
      }
    },
    [GET_BUCKET_JOURNIES]: async ({ commit }: any, payload: any) => {
      commit(SET_BUCKET_JOURNIES, { isLoading: true });

      try {
        const result: AxiosResponse = await BucketJourney.getBucketJournies(
          payload as GetBucketJourney
        );

        if (result) {
          if (result.data.status) {
            commit(SET_BUCKET_JOURNIES, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_BUCKET_JOURNIES, { isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_BUCKET_JOURNIES, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_BUCKET_JOURNIES, { data: null, isLoading: false });

        if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
          commit(SET_ERRORMSG, "Request timed out. Please try again");
        } else if (error.response?.status === 500) {
          commit(SET_ERRORMSG, "Server error. Please try again");
        } else if (error.response?.status === 404) {
          commit(SET_ERRORMSG, "Bucket journies not found");
        } else if (!error.response) {
          commit(SET_ERRORMSG, "Network error. Please check your connection");
        } else {
          commit(SET_ERRORMSG, error.response?.data?.message || "Failed to load bucket journies");
        }

        return false;
      }
    },
    [EDIT_BUCKET_JOURNEY]: async ({ commit }: any, payload: any) => {
      commit(SET_BUCKET_JOURNEY, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await BucketJourney.editBucketJourney(
          payload as EditBucketJourney
        );

        if (result) {
          if (result.data.status) {
            commit(SET_BUCKET_JOURNEY, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_BUCKET_JOURNEY, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_BUCKET_JOURNEY, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_BUCKET_JOURNEY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, error.response?.data?.message || "Failed to edit bucket journey");
        return false;
      }
    },
    [DELETE_BUCKET_JOURNEY]: async ({ commit }: any, payload: string) => {
      commit(SET_BUCKET_JOURNEY, { data: { id: payload }, isLoading: true });

      try {
        const result: AxiosResponse = await BucketJourney.deleteBucketJourney(payload);

        if (result) {
          if (result.data.status) {
            commit(SET_BUCKET_JOURNEY, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_BUCKET_JOURNEY, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_BUCKET_JOURNEY, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_BUCKET_JOURNEY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, error.response?.data?.message || "Failed to delete bucket journey");
        return false;
      }
    },
    [CLEAR_BUCKET_JOURNEY_ISLOADING]: ({ commit }) => {
      commit(SET_BUCKET_JOURNEY, { isLoading: false });
      commit(SET_BUCKET_JOURNIES, { isLoading: false });
    },
  },
};

export default bucketJourney;
